import Header from './Header/Header';
import Footer from './Footer/Footer';

export { Header, Footer };
